enum TransactionStatus {
	Pending = 'Pending',
	Processed = 'Processed',
	Blocked = 'Blocked',
	Canceled = 'Canceled',
}

export default TransactionStatus;
